<template>
  <div>
    <!-- HERO -->
    <section class="hero relative min-h-screen flex items-center justify-center overflow-hidden">
      <div class="hero-overlay absolute inset-0 z-2"></div>
      <div class="absolute inset-0 z-1">
        <img src="../assets/Ciclismo-2026.png" alt="5° Pedal no Paraíso 2026" class="w-full h-full object-cover hero-img" />
      </div>
      <div class="relative z-10 text-center text-white px-4 pt-20 md:pt-0">
        <h1 class="text-3xl md:text-6xl lg:text-7xl font-extrabold uppercase tracking-tight animate-fade-in-up">
          5° Pedal no <span class="text-orange">Paraíso</span>
        </h1>
        <p class="text-lg md:text-2xl mt-4 font-light tracking-widest animate-fade-in-up delay-100" style="opacity:0">
          01 DE MAIO &nbsp;|&nbsp; XERÉM &nbsp;|&nbsp; 12KM
        </p>

        <div class="flex flex-wrap justify-center gap-3 md:gap-6 mt-6 md:mt-8 animate-fade-in-up delay-200" style="opacity:0">
          <div class="glass rounded-xl px-6 py-4 text-center" style="min-width:100px">
            <span class="text-3xl md:text-4xl font-extrabold text-orange">12 KM</span>
            <p class="text-xs uppercase tracking-wider mt-1">de percurso</p>
          </div>
          <div class="glass rounded-xl px-6 py-4 text-center" style="min-width:100px">
            <span class="text-3xl md:text-4xl font-extrabold text-orange">15 MIL</span>
            <p class="text-xs uppercase tracking-wider mt-1">kits exclusivos</p>
          </div>
          <div class="glass rounded-xl px-6 py-4 text-center" style="min-width:100px">
            <span class="text-3xl md:text-4xl font-extrabold text-orange">5 MIL</span>
            <p class="text-xs uppercase tracking-wider mt-1">kits femininos</p>
          </div>
        </div>

        <div class="mt-10 text-white font-bold text-lg md:text-xl px-10 py-4 rounded-full animate-pulse-cta animate-fade-in-up delay-300 uppercase tracking-wider btn-orange inline-block">
          Inscrições Abertas
        </div>
      </div>

      <div class="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce-arrow">
        <svg class="w-8 h-8 text-white opacity-75" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>

    <!-- SOBRE -->
    <section class="section-blue py-20 px-4 relative overflow-hidden">
      <div class="geo-shape geo-1"></div>
      <div class="geo-shape geo-2"></div>
      <div class="max-w-6xl mx-auto relative z-10">
        <h2 class="text-3xl md:text-4xl font-extrabold text-white text-center mb-12 uppercase">
          Sobre o <span class="text-orange">Evento</span>
        </h2>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div class="text-white text-base md:text-lg leading-relaxed space-y-6" data-reveal>
            <p>Prepare o fôlego: o maior encontro gratuito de ciclistas do Rio de Janeiro vem aí! A 5ª edição do Pedal no Paraíso acontece em Xerém e é realizada pela Prefeitura de Duque de Caxias, em parceria com o governo do estado.</p>
            <p>O trajeto de 12 km recebe ciclistas profissionais, amadores e suas famílias, com pontos de hidratação, apoio, segurança e suporte médico. Os 15 mil primeiros a se inscrever recebem kit exclusivo, e as 5 mil primeiras mulheres inscritas garantem um kit diferenciado.*</p>
            <p class="text-sm opacity-50 mt-2">* Tamanhos sujeitos à disponibilidade de estoque.</p>
            <p>A chegada na Fazenda Paraíso oferece lanches, apresentações musicais e momentos de bem-estar e de diversão.</p>
          </div>
          <div class="grid grid-cols-2 gap-4" data-reveal>
            <div class="glass rounded-2xl p-6 text-center text-white card-hover">
              <span class="text-4xl">🚴</span>
              <h3 class="text-xl font-bold mt-3">Profissionais</h3>
              <p class="text-sm mt-2 opacity-75">e amadores</p>
            </div>
            <div class="glass rounded-2xl p-6 text-center text-white card-hover">
              <span class="text-4xl">👨‍👩‍👧‍👦</span>
              <h3 class="text-xl font-bold mt-3">Famílias</h3>
              <p class="text-sm mt-2 opacity-75">evento para todos</p>
            </div>
            <div class="glass rounded-2xl p-6 text-center text-white card-hover">
              <span class="text-4xl">🎁</span>
              <h3 class="text-xl font-bold mt-3">Sorteios</h3>
              <p class="text-sm mt-2 opacity-75">exclusivos</p>
            </div>
            <div class="glass rounded-2xl p-6 text-center text-white card-hover">
              <span class="text-4xl">🏥</span>
              <h3 class="text-xl font-bold mt-3">Suporte</h3>
              <p class="text-sm mt-2 opacity-75">médico completo</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- PROGRAMAÇÃO -->
    <section class="py-20 px-4" style="background:#F5F5F5">
      <div class="max-w-4xl mx-auto">
        <h2 class="text-3xl md:text-4xl font-extrabold text-center mb-16 uppercase" style="color:#195493">
          Programação
        </h2>
        <div class="timeline" data-reveal>
          <div class="timeline-item" v-for="(item, i) in programacao" :key="i">
            <div class="timeline-dot"></div>
            <div class="timeline-content">
              <span class="text-orange font-extrabold text-lg">{{ item.time }}</span>
              <h3 class="text-xl font-bold mt-1" style="color:#195493">{{ item.title }}</h3>
              <p class="text-gray-600 mt-1">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- RETIRADA KITS -->
    <section class="gradient-orange py-20 px-4">
      <div class="max-w-6xl mx-auto">
        <h2 class="text-3xl md:text-4xl font-extrabold text-white text-center mb-4 uppercase">Retirada dos Kits</h2>
        <p class="text-center text-white text-lg mb-4">25 a 28 de abril &nbsp;|&nbsp; 8h às 17h</p>
        <p class="text-center text-white text-sm mb-12 opacity-75">Mediante apresentação do QR code de inscrição e documento com foto</p>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6" data-reveal>
          <div v-for="(local, i) in locais" :key="i" class="bg-white rounded-2xl p-8 shadow-xl card-hover">
            <div class="w-14 h-14 rounded-full flex items-center justify-center mb-4" style="background:#E8652D">
              <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
            </div>
            <h3 class="text-xl font-bold mb-2" style="color:#195493">{{ local.nome }}</h3>
            <p class="text-gray-600 text-sm">{{ local.endereco }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA FINAL -->
    <section class="py-20 px-4 text-center" style="background:#0f3460">
      <div class="max-w-3xl mx-auto" data-reveal>
        <h2 class="text-3xl md:text-5xl font-extrabold text-white uppercase mb-6">
          Venha pedalar <span class="text-orange">conosco!</span>
        </h2>
        <p class="text-white text-lg mb-10 opacity-75">Inscrições de 9 a 22 de abril. Garanta sua vaga e seu kit exclusivo.</p>
        <button @click="$emit('open-form')" class="btn-orange text-white font-bold text-xl px-12 py-5 rounded-full animate-pulse-cta uppercase tracking-wider">
          Inscreva-se Agora
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Art",
  data() {
    return {
      programacao: [
        { time: "7h", title: "Concentração", desc: "Hotel Escola de Duque de Caxias, Xerém" },
        { time: "8h", title: "Largada", desc: "Início do percurso de 12 km rumo à Fazenda Paraíso" },
        { time: "—", title: "Percurso", desc: "Pontos de hidratação, apoio e segurança ao longo do trajeto" },
        { time: "🏁", title: "Chegada", desc: "Fazenda Paraíso — lanches, música e sorteios exclusivos" },
      ],
      locais: [
        { nome: "Hotel Escola de Duque de Caxias", endereco: "Rua Pastor Manoel Avelino de Souza, Vila Santa Alice, Xerém, 4º Distrito" },
        { nome: "Caxias Shopping", endereco: "Rod. Washington Luiz, 2895 - Parque Duque, Duque de Caxias" },
        { nome: "Vila Olímpica", endereco: "R. Garibaldi, S/N - Jardim Vinte e Cinco de Agosto, Duque de Caxias" },
      ],
    };
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("animate-in"); }),
      { threshold: 0.1 }
    );
    document.querySelectorAll("[data-reveal]").forEach((el) => observer.observe(el));
  },
};
</script>

<style scoped>
.text-orange { color: #E8652D; }
.btn-orange { background: #E8652D; transition: background 0.3s; }
.btn-orange:hover { background: #c9521f; }
.section-blue { background: #195493; }
.hero-img { filter: brightness(0.45); }
.hero-overlay { background: linear-gradient(to bottom, rgba(15,52,96,0.3) 0%, rgba(15,52,96,0.85) 100%); }
.z-1 { z-index: 1; }
.z-2 { z-index: 2; }
.geo-shape { position: absolute; border-radius: 50%; opacity: 0.06; background: white; }
.geo-1 { width: 400px; height: 400px; top: -100px; right: -100px; }
.geo-2 { width: 300px; height: 300px; bottom: -80px; left: -80px; }
.gradient-orange { background: linear-gradient(135deg, #E8652D 0%, #D4A012 100%); }
.card-hover { transition: transform 0.3s, box-shadow 0.3s; }
.card-hover:hover { transform: translateY(-6px); box-shadow: 0 12px 30px rgba(0,0,0,0.15); }

.timeline { position: relative; padding-left: 40px; }
.timeline::before { content: ''; position: absolute; left: 15px; top: 0; bottom: 0; width: 3px; background: linear-gradient(to bottom, #E8652D, #D4A012); border-radius: 2px; }
.timeline-item { position: relative; margin-bottom: 2.5rem; }
.timeline-dot { position: absolute; left: -33px; top: 5px; width: 16px; height: 16px; background: #E8652D; border-radius: 50%; border: 3px solid #F5F5F5; box-shadow: 0 0 0 3px #E8652D; }
.timeline-content { background: white; border-radius: 1rem; padding: 1.5rem; box-shadow: 0 4px 15px rgba(0,0,0,0.08); transition: transform 0.3s; }
.timeline-content:hover { transform: translateX(8px); }
</style>
